import isEmpty from 'lodash.isempty';

export const EMPTY_OPTIONS = [
  {
    label: '',
    value: null,
  },
];

export const getOccupationCategoryOptions = (occupationCategories) => {
  if (!occupationCategories || isEmpty(occupationCategories)) {
    return EMPTY_OPTIONS;
  }

  let start = 0;
  const categoryOptions = [];

  occupationCategories.forEach((option) => {
    start += 1; // BE uses 1-based index
    categoryOptions.push({
      [`label`]: option,
      [`value`]: start,
    });
  });

  return categoryOptions;
};

export const getIncomeSourceOptions = (incomeSourceList) => {
  if (!incomeSourceList || isEmpty(incomeSourceList)) {
    return EMPTY_OPTIONS;
  }

  const options = [];

  incomeSourceList.forEach((option) => {
    options.push({
      [`label`]: option.Caption,
      [`value`]: option.IncomeSourceTypeID,
    });
  });

  return options;
};
